export const INVALID = 'INVALID';
export const VALID = 'VALID';
export const CONTROL = 'control';
export const ND = 'ND';

export const BIRTHDATE_DEFAULTS = {
  YEAR: 'BOOKING_MODULE.YEAR',
  MONTH: 'BOOKING_MODULE.MONTH',
  MONTH_NUMBER: 0,
  DAY: 'BOOKING_MODULE.DAY'
};

export const BIRTHDATE_SCROLL = {
  YEAR: '1988',
  MONTH: 'MONTHS.JUNE',
  DAY: '15'
};

export const START_ADULTS_YEAR = 1900;
export const FEBRUARY_NUMBER = 2;
export const PASSENGER_CHILDREN_RANGE_AGES = { MIN: 2, MAX: 11 };
export const INFANTS_RANGE_AGES_IN_MONTH = { MIN: 0, MAX: 23 };
export const GUEST_CHILDREN_RANGE_AGES = { MIN: 0, MAX: 11 };
export const MONTHS_IN_YEAR = 12;
export const MS_IN_ONE_DAY = 24 * 60 * 60 * 1000;
export const DAYS_IN_YEAR = 365.25;

export const BOOKING_FORM_INPUTS = {
  TRAVELERS: 'Travelers',
  PHONE: 'Phone',
  EMAIL: 'Email',
  COMMENTS: 'Comments',
  TERMS: 'Terms',
  EXTRA_TERMS: 'ExtraTerms',
  CIVITATIS_TERMS: 'CivitatisTerms',
  BILLING: 'Billing',
  EXTRA_QUESTIONS: 'ExtraQuestions',
};

export const TRAVELER_FORM_INPUTS = {
  PAX_TYPE: 'PaxType',
  FIRST_NAME: 'FirstName',
  SECOND_NAME: 'SecondName',
  LAST_NAME: 'LastName',
  GENDER: 'Gender',
  DOCUMENT_NUMBER: 'DocumentNumber',
  FREQUENT_FLYER_AIRLINE: 'FrequentFlyerAirline',
  FREQUENT_FLYER: 'FrequentFlyer',
  NATIONALITY: 'Nationality',
  DOCUMENT_ID: 'ConfigurationDocumentId',
  DOB: 'DOB',
  USER_ID: 'UserId',
  INTERNATIONAL_DOCUMENT_REQUIRED: 'InternationalDocumentRequired',
  BONVOY_NUMBER: 'BonvoyNumber',
};

export const BILLING_FORM_INPUTS = {
  BILLING_INFO: 'billing_info',
  USER_ID: 'user_id',
};

export const PERSON_FORM_INPUTS = {
  NATURAL_PERSON: 'natural_person',
  DOCUMENT_NUMBER: 'document_number',
  DOCUMENT_ID: 'configuration_document_id',
  EMAIL: 'email_address',
  FIRST_NAME: 'first_name',
  SECOND_NAME: 'middle_name',
  LEGAL_NAME: 'legal_name',
  LAST_NAME: 'last_name',
  GENDER: 'gender',
  PHONE: 'phone_number',
  ADDRESS: 'address',
  FISCAL_RESPONSIBILITY: 'fiscal_responsibility',
};

export const PERSON_ADDRESS_FORM_INPUTS = {
  STREET: 'street',
  CITY_CODE: 'city_code',
  COUNTRY_CODE: 'country_code',
  POSTAL_CODE: 'postal_code',
  STATE_CODE: 'state_code',
  NEIGHBORHOOD: 'neighborhood',
  COMPLEMENT: 'complement'
};
